<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">

      <div class="search-all-box">
        <div></div>
        <div class="right-option-box">
          <a-button class="option-btn" type="primary" @click="handleModalVisible('showAddModal',true, null)">添加类型</a-button>
        </div>
      </div>
      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" rowKey="id" size="small" :pagination="false">

          <template slot="classname" slot-scope="text,record">
            <div class="erweima-icon" @click="getQrcode(record)"></div>{{text}}
          </template>
          <template slot="action" slot-scope="text,record">
            <a-button type="link" @click="handleModalVisible('showEditModal',true, record)">编辑</a-button>
            <a-button type="link" @click="handleModalVisible('showDeleteModal',true, record)">删除</a-button>
          </template>
        </a-table>

        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />

      </div>

      <CommonModal v-model="showDeleteModal" title="删除类型" confirmText="确定" @confirm="handleDeleteConfirm">
        <div class="delete-modal">
          确定删除类型吗？
        </div>
      </CommonModal>

      <CommonModal v-model="showEditModal" title="编辑类型" confirmText="确定" @confirm="handleEditConfirm">
        <div class="search-all-box edit-modal">
          <a-form>
            <a-form-item label="类型名称：">
              <a-input class="search-input" placeholder="请输入类型名称" v-model="edit_name"></a-input>
            </a-form-item>
          </a-form>
        </div>
      </CommonModal>

      <CommonModal v-model="showAddModal" title="添加类型" confirmText="确定" @confirm="handleAddConfirm">
        <div class="search-all-box edit-modal">
          <a-form>
            <a-form-item label="类型名称：">
              <a-input class="search-input" placeholder="请输入类型名称" v-model="add_name"></a-input>
            </a-form-item>
          </a-form>
        </div>
      </CommonModal>

    </div>
  </div>

</template>
<script>

import CommonModal from "../../../../components/CommonModal"
import { mapActions, mapState } from "vuex";
// import services from "../../../../assets/js/services";
import Bread from "../../../../components/school/Bread.vue";
export default {
  name: "stadiumType",
  components: {
    CommonModal,
    Bread
  },
  data() {
    return {
      breadConfig: [{ name: "场馆类型" }],
      school_code: localStorage.getItem("schoolCode"),
      showAddModal: false,
      showEditModal: false,
      showDeleteModal: false,
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      add_name: "", // 添加的场馆类型
      edit_name: "", // 添加的场馆类型
      columns: [
        {
          title: "类型名称",
          dataIndex: "name",
          scopedSlots: { customRender: 'classname' },
        },
        {
          title: "更新时间",
          dataIndex: "updated_at",
        },
        {
          title: "更新人",
          dataIndex: "updated_name",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: '200px'
        },
      ],

    };
  },
  mounted() {
    if (!(this.appsUserInfo.user_type == 2 || (this.appsUserInfo.user_type == 1 && this.appsUserInfo.role_ids == 2))) {
      this.$router.push(`/${this.school_code}/school/teach`)
    }
    this.getTableList()
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  methods: {
    ...mapActions(["getStadiumType", "addStadiumType", "editStadiumType", "getStadiumTypeInfo"]),
    // 获取类型列表 表格数据
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
      };
      this.getStadiumType(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    // 搜索按钮
    onSearch() {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    // 分页点击事件
    pageChange(val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    // 搜索重置按钮
    resetForm() {
      // this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    // 弹窗显示隐藏
    handleModalVisible(key, val, item) {
      this[key] = val
      if (key == 'showAddModal') {
        this.add_name = ''
      }
      if (item) {
        this.classItem = item
        if (key == 'showEditModal') {
          this.edit_name = item.name
        }
      }
    },
    // 删除弹窗 - 确认事件
    handleDeleteConfirm() {
      this.classEditAndDelete(2, { id: this.classItem.id, data: { _method: 'delete' } })
      this.handleModalVisible("showDeleteModal", false, null)
    },
    // 类型添加和删除方法
    classEditAndDelete(type, params) {
      this.editStadiumType(params).then(res => {
        if (res.code == "0000") {
          this.$message.success(`${type == 1 ? '编辑' : '删除'}成功`)
          this.resetForm()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 编辑类型弹窗 - 确认事件
    handleEditConfirm() {
      let that = this
      if (this.edit_name) {
        if (this.edit_name.length > 100) {
          this.$message.error("类型名称不能超过100个字")
        } else {
          that.classEditAndDelete(1, { id: this.classItem.id, data: { name: this.edit_name, _method: 'put' } })
          this.handleModalVisible("showEditModal", false, null)
        }
      } else {
        this.$message.error("请输入类型名称")
      }
    },
    // 添加类型弹窗 - 确认事件
    handleAddConfirm() {
      let that = this
      if (this.add_name) {
        if (this.add_name.length > 100) {
          this.$message.error("类型名称不能超过100个字")
        } else {
          this.addStadiumType({ name: this.add_name, }).then(res => {
            if (res.code == "0000") {
              that.$message.success(`添加成功`)
              that.resetForm()
            } else {
              that.$message.error(res.message)
            }
          })
          this.handleModalVisible("showAddModal", false, null)
        }
      } else {
        this.$message.error("请输入类型名称")
      }
    }
  },
};
</script>

<style lang="less" scoped>
.invite-container {
  position: relative;
  .class-activity {
    font-weight: bold;
    font-size: 16px;
    color: #373536;
    text-align: center;
  }
  .class-info {
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #3c3c3e;
    padding-top: 9px;
    div:not(:last-child) {
      margin-right: 20px;
    }
  }
  .invite-content {
    padding-top: 21px;
    .invite-code {
      display: flex;
      justify-content: center;
      height: 32px;
      .invite-left {
        width: 300px;
        background: #ffffff;
        border-radius: 16px 0 0 16px;
        border: 1px solid #dcdfe6;
        display: flex;
        align-items: center;
        padding: 0 16px;
        .invite-label,
        .invite-number {
          font-size: 14px;
          color: #a82822;
        }
      }
      .invite-copy {
        width: 101px;
        height: 32px;
        background: #b84b3c;
        border-radius: 0px 16px 16px 0px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        font-size: 14px;
        color: #ffffff;
      }
    }
    .invite-qrcode {
      text-align: center;
      padding-top: 24px;
      img {
        width: 161px;
        height: 161px;
      }
    }
  }
  &.download {
    .invite-copy {
      display: none;
    }
    .invite-left {
      justify-content: center;
      text-align: center;
      border: none !important;
    }
  }
}
.edit-modal {
  /deep/ .ant-form-item {
    display: flex;
    margin-right: 0;
    .ant-form-item-label {
      color: #373536;
    }
    .ant-input {
      width: 281px;
    }
  }
}
.delete-modal {
  font-weight: bold;
  font-size: 16px;
  color: #373536;
  text-align: center;
}
.erweima-icon {
  width: 13px;
  height: 13px;
  cursor: pointer;
  background: url("../../../../assets/image/school/common/erweima.png")
    no-repeat center/cover;
  vertical-align: -1px;
  display: inline-block;
  margin-right: 6px;
}
// 下载的样式
.user-download-box {
  position: fixed;
  top: 0;
  right: -800px;
  width: 700px;
  background: #ffffff;
  padding: 0 0 45px;
  box-sizing: border-box;
  text-align: center;
  .bg-line {
    position: absolute;
    z-index: 1;
    top: 0;
    width: 100%;
    height: 80px;
    background: linear-gradient(0deg, #ffffff 0%, #ffcbc9 100%);
    opacity: 0.8;
  }
  .activity {
    position: relative;
    z-index: 10;
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #373536;
    padding: 64px 0 44px;
  }
  .class {
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
    font-weight: normal;
    margin-bottom: 20px;
    color: #3c3c3e;
  }
  .teacher {
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    color: #3c3c3e;
    margin-bottom: 20px;
    line-height: 32px;
  }
  .code-line {
    margin: 20px auto 0;
    width: 368px;
    height: 54px;
    line-height: 54px;
    font-size: 24px;
    color: #a82822;
    background: #fff8f7;
    text-align: center;
  }
}
</style>
